import React from "react";

export default function MensConference2025() {
  return (
    <div className="max-w-3xl mx-auto bg-white shadow-md rounded-lg p-6 my-6">
      <h1 className="text-2xl font-bold text-center text-gray-800 mb-2">
        Fall Men's Conference 2025: Faithful Stewards of God's Grace
      </h1>
      <h2 className="text-xl text-center text-red-600 mb-4">
        🚨 Important Location Change 🚨
      </h2>
      <h2 className="text-xl text-center text-red-600 mb-4">
        Friday 10/24 & Saturday 10/25
      </h2>

      <p
        className="bg-yellow-100 p-3 rounded font-semibold text-center mb-4"
      >
        The Men’s Conference will now be held at{" "}
        <strong>Calvary Baptist – Calvary Center</strong>, not at an outside
        conference center.
      </p>

      <div className="bg-gray-50 border-l-4 border-blue-600 p-4 mb-4">
        <h3 className="text-lg font-semibold text-gray-800 mb-2">
          Updated Schedule
        </h3>

        <div className="mb-3">
          <div className="font-bold text-gray-800">
            Friday Evening – 6:00 PM to 9:30 PM
          </div>
          <div className="italic text-gray-600">
            Dinner &amp; Session 1 – Kelly Fath
          </div>
          <div>
            “Using Trials for Growth – Seeing God's Hand in the Journey”
          </div>
        </div>

        <div className="mb-3">
          <div className="font-bold text-gray-800">Saturday Morning – 9:00 AM</div>
          <div className="italic text-gray-600">
            Breakfast (Mission Conference Donuts – the good ones!)
          </div>
        </div>

        <div className="mb-3">
          <div className="font-bold text-gray-800">10:00 AM – Randy Oswald</div>
          <div>
            “A Steward of the King - Managing His Resources Well”
          </div>
        </div>

        <div className="mb-3">
          <div className="font-bold text-gray-800">11:00 AM – Dave Wyand</div>
          <div>
            “We are Created to Work – Seeing My Work as a Calling from God”
          </div>
        </div>

        <div className="mb-3">
          <div className="font-bold text-gray-800">
            11:45 AM – Lunch (Buffalo's Best Wings)
          </div>
        </div>

        <div className="mb-3">
          <div className="font-bold text-gray-800">12:45 PM – Jim Houser</div>
          <div>
            “Pro Tips for Husbands &amp; Dads – Using God’s Word as a Guide to
            Serve Your Family”
          </div>
        </div>

        <div className="mb-3">
          <div className="font-bold text-gray-800">1:45 PM – Eric Johnson</div>
          <div>
            “Raising Up a Child in the Way He Should Go – Maximizing My
            Influence to Guide Them to Christ”
          </div>
        </div>

        <div className="mb-3">
          <div className="font-bold text-gray-800">
            3:00 PM – Interview with Jeff Nitengale
          </div>
          <div>
            “Every Day Faith – How a Farmer Trusts the Owner of the Cattle on a
            Thousand Hills”
          </div>
        </div>

        <div className="mb-3">
          <div className="font-bold text-gray-800">4:30 PM</div>
          <div>Conference wrap-up – Stick around for fellowship!</div>
        </div>

        <div className="italic text-gray-700 mt-3">
          Each session begins with a <strong>worship set</strong> led by James
          Faulkner, and speakers will bring focused{" "}
          <strong>20–30 minute messages</strong>.
        </div>

        <p className="mt-3">
          <strong>Cost:</strong> $30 per day, or $60 for the full event.
          <br />
          Already paid $95? Contact <strong>Tyler</strong> for a $35 refund.
          <br />
          Scholarships are available — don’t let cost be a barrier.
        </p>
      </div>

      <p className="mb-4">
        In addition to worship and teaching, enjoy{" "}
        <strong>
          yard games, cornhole, fire pit, and even axe throwing
        </strong>{" "}
        for breakout fun and connection.
      </p>

      <a
        href="https://cbcky.churchcenter.com/registrations/events/2977967"
        className="inline-block px-5 py-3 bg-blue-700 text-white rounded hover:bg-blue-800 transition mb-4"
        target="_blank"
        rel="noreferrer"
      >
        Register Now
      </a>

      <p className="mb-4">
        This change was made with you in mind. If price, distance or travel was
        a barrier before, that’s gone. We’d love to see you there—come hungry,
        come expectant, and come ready to lock arms with other men and{" "}
        <strong>Fight For What Matters!</strong>.
      </p>

      <div className="border-t pt-4 text-sm text-center text-gray-600 mt-6">
        <p>
          “Do not be afraid of them. Remember the Lord, who is great and
          awesome, and fight for your brothers, your sons, your daughters, your
          wives, and your homes.” – Nehemiah 4:14
        </p>
        <p>414 Ministry | Calvary Baptist Church</p>
      </div>
    </div>
  );
}
